"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const FormTitle = ({ children }) => (React.createElement("h2", { className: 'center-xs', style: { margin: '5rem 0' } }, children));
exports.default = FormTitle;
